import { render, staticRenderFns } from "./checklistPage.vue?vue&type=template&id=2bc9e82b&scoped=true&lang=pug&"
import script from "./checklistPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./checklistPage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./checklistPage.vue?vue&type=style&index=0&id=2bc9e82b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc9e82b",
  null
  
)

export default component.exports